export function REQUEST(actionType) {
    return {
        type: actionType,
    };
}

export function SUCCESS(actionType, response) {
    return {
        type: actionType,
        payload: response,
    };
}

export function FAILURE(actionType, error) {
    return {
        type: actionType,
        payload: error,
    };
}

export const ATTENDANCE_REQUEST = {
    INITIALIZE_ATTENDANCE_REQUEST: 'INITIALIZE_ATTENDANCE_REQUEST',
    INITIALIZE_ATTENDANCE_SUCCESS: 'INITIALIZE_ATTENDANCE_SUCCESS',
    INITIALIZE_ATTENDANCE_FAILURE: 'INITIALIZE_ATTENDANCE_FAILURE',
    ADD_ATTENDANCE_REQUEST: 'ADD_ATTENDANCE_REQUEST',
    ADD_ATTENDANCE_SUCCESS: 'ADD_ATTENDANCE_SUCCESS',
    ADD_ATTENDANCE_FAILURE: 'ADD_ATTENDANCE_FAILURE',
    UPDATE_ATTENDANCE_REQUEST: 'UPDATE_ATTENDANCE_REQUEST',
    UPDATE_ATTENDANCE_SUCCESS: 'UPDATE_ATTENDANCE_SUCCESS',
    UPDATE_ATTENDANCE_FAILURE: 'UPDATE_ATTENDANCE_FAILURE',
    SET_SELECTED_DATE_REQUEST: 'SET_SELECTED_DATE_REQUEST',
    SET_SELECTED_DATE_SUCCESS: 'SET_SELECTED_DATE_SUCCESS',
    SET_SELECTED_DATE_FAILURE: 'SET_SELECTED_DATE_FAILURE',
};

export const USER_REQUEST = {

    LOGIN_REQUEST: 'LOGIN_REQUEST',
    LOGIN_SUCCESS: 'LOGIN_SUCCESS',
    LOGIN_FAILURE: 'LOGIN_FAILURE',
    LOGOUT_REQUEST: 'LOGOUT_REQUEST',
    LOGOUT_SUCCESS: 'LOGOUT_SUCCESS',
    LOGOUT_FAILURE: 'LOGOUT_FAILURE',
    GET_ALL_USERS_REQUEST: 'GET_ALL_USERS_REQUEST',
    GET_ALL_USERS_SUCCESS: 'GET_ALL_USERS_SUCCESS',
    GET_ALL_USERS_FAILURE: 'GET_ALL_USERS_FAILURE',
    GET_USER_REQUEST: 'GET_USER_REQUEST',
    GET_USER_SUCCESS: 'GET_USER_SUCCESS',
    GET_USER_FAILURE: 'GET_USER_FAILURE',
    UPDATE_USER_REQUEST: 'UPDATE_USER_REQUEST',
    UPDATE_USER_SUCCESS: 'UPDATE_USER_SUCCESS',
    UPDATE_USER_FAILURE: 'UPDATE_USER_FAILURE',
    UPDATE_EMPLOYEE_REQUEST: 'UPDATE_EMPLOYEE_REQUEST',
    UPDATE_EMPLOYEE_SUCCESS: 'UPDATE_EMPLOYEE_SUCCESS',
    UPDATE_EMPLOYEE_FAILURE: 'UPDATE_EMPLOYEE_FAILURE',
    REMOVE_USER_REQUEST: 'REMOVE_USER_REQUEST',
    REMOVE_USER_SUCCESS: 'REMOVE_USER_SUCCESS',
    REMOVE_USER_FAILURE: 'REMOVE_USER_FAILURE',
    UPDATE_PASSWORD_REQUEST: 'UPDATE_PASSWORD_REQUEST',
    UPDATE_PASSWORD_SUCCESS: 'UPDATE_PASSWORD_SUCCESS',
    UPDATE_PASSWORD_FAILURE: 'UPDATE_PASSWORD_FAILURE',
    CREATE_REQUEST: 'CREATE_REQUEST',
    CREATE_SUCCESS: 'CREATE_SUCCESS',
    CREATE_FAILURE: 'CREATE_FAILURE',
    RESET_USER_DATA: 'RESET_USER_DATA',
    FORGET_USER_PASSWORD :"FORGET_USER_PASSWORD",
    RESET_USER_PASSWORD: "RESET_USER_PASSWORD"
};

export const LEAVE_REQUEST = {
    CREATE_LEAVE_REQUEST: 'CREATE_LEAVE_REQUEST',
    CREATE_LEAVE_SUCCESS: 'CREATE_LEAVE_SUCCESS',
    CREATE_LEAVE_FAILURE: 'CREATE_LEAVE_FAILURE',
    GET_LEAVE_REQUEST: 'GET_LEAVE_REQUEST',
    GET_LEAVE_SUCCESS: 'GET_LEAVE_SUCCESS',
    GET_LEAVE_FAILURE: 'GET_LEAVE_FAILURE',
    UPDATE_LEAVE_REQUEST: 'UPDATE_LEAVE_REQUEST',
    UPDATE_LEAVE_SUCCESS: 'UPDATE_LEAVE_SUCCESS',
    UPDATE_LEAVE_FAILURE: 'UPDATE_LEAVE_FAILURE',
    DELETE_LEAVE_REQUEST: 'DELETE_LEAVE_REQUEST',
    DELETE_LEAVE_SUCCESS: 'DELETE_LEAVE_SUCCESS',
    DELETE_LEAVE_FAILURE: 'DELETE_LEAVE_FAILURE',
};

export const EMPLOYEE_REQUEST = {
    ADD: {
        REQUEST: 'ADD_EMPLOYEE_REQUEST',
        SUCCESS: 'ADD_EMPLOYEE_SUCCESS',
        FAILURE: 'ADD_EMPLOYEE_FAILURE',
    },
    GET_ALL: {
        REQUEST: 'GET_ALL_EMPLOYEES_REQUEST',
        SUCCESS: 'GET_ALL_EMPLOYEES_SUCCESS',
        FAILURE: 'GET_ALL_EMPLOYEES_FAILURE',
    },
    GET: {
        REQUEST: 'GET_EMPLOYEE_REQUEST',
        SUCCESS: 'GET_EMPLOYEE_SUCCESS',
        FAILURE: 'GET_EMPLOYEE_FAILURE',
    },
    UPDATE: {
        REQUEST: 'UPDATE_EMPLOYEE_REQUEST',
        SUCCESS: 'UPDATE_EMPLOYEE_SUCCESS',
        FAILURE: 'UPDATE_EMPLOYEE_FAILURE',
    },
    DELETE: {
        REQUEST: 'DELETE_EMPLOYEE_REQUEST',
        SUCCESS: 'DELETE_EMPLOYEE_SUCCESS',
        FAILURE: 'DELETE_EMPLOYEE_FAILURE',
    },
};

export const CHECKIN_REQUEST = {
    ADD_CHECKIN_REQUEST: 'ADD_CHECKIN_REQUEST',
    ADD_CHECKIN_SUCCESS: 'ADD_CHECKIN_SUCCESS',
    ADD_CHECKIN_FAILURE: 'ADD_CHECKIN_FAILURE',
    GET_ALL_CHECKINS_REQUEST: 'GET_ALL_CHECKINS_REQUEST',
    GET_ALL_CHECKINS_SUCCESS: 'GET_ALL_CHECKINS_SUCCESS',
    GET_ALL_CHECKINS_FAILURE: 'GET_ALL_CHECKINS_FAILURE',
    GET_CHECKIN_REQUEST: 'GET_CHECKIN_REQUEST',
    GET_CHECKIN_SUCCESS: 'GET_CHECKIN_SUCCESS',
    GET_CHECKIN_FAILURE: 'GET_CHECKIN_FAILURE',
    UPDATE_CHECKIN_REQUEST: 'UPDATE_CHECKIN_REQUEST',
    UPDATE_CHECKIN_SUCCESS: 'UPDATE_CHECKIN_SUCCESS',
    UPDATE_CHECKIN_FAILURE: 'UPDATE_CHECKIN_FAILURE',
    DELETE_CHECKIN_REQUEST: 'DELETE_CHECKIN_REQUEST',
    DELETE_CHECKIN_SUCCESS: 'DELETE_CHECKIN_SUCCESS',
    DELETE_CHECKIN_FAILURE: 'DELETE_CHECKIN_FAILURE',
};

export const OFF_REQUEST = {
    ADD_OFF_REQUEST: 'ADD_OFF_REQUEST',
    ADD_OFF_REQUEST_SUCCESS: 'ADD_OFF_REQUEST_SUCCESS',
    ADD_OFF_REQUEST_FAILURE: 'ADD_OFF_REQUEST_FAILURE',
    GET_ALL_OFF_REQUESTS: 'GET_ALL_OFF_REQUESTS',
    GET_ALL_OFF_REQUESTS_SUCCESS: 'GET_ALL_OFF_REQUESTS_SUCCESS',
    GET_ALL_OFF_REQUESTS_FAILURE: 'GET_ALL_OFF_REQUESTS_FAILURE',
    GET_OFF_REQUEST: 'GET_OFF_REQUEST',
    GET_OFF_REQUEST_SUCCESS: 'GET_OFF_REQUEST_SUCCESS',
    GET_OFF_REQUEST_FAILURE: 'GET_OFF_REQUEST_FAILURE',
    UPDATE_OFF_REQUEST: 'UPDATE_OFF_REQUEST',
    UPDATE_OFF_REQUEST_SUCCESS: 'UPDATE_OFF_REQUEST_SUCCESS',
    UPDATE_OFF_REQUEST_FAILURE: 'UPDATE_OFF_REQUEST_FAILURE',
    DELETE_OFF_REQUEST: 'DELETE_OFF_REQUEST',
    DELETE_OFF_REQUEST_SUCCESS: 'DELETE_OFF_REQUEST_SUCCESS',
    DELETE_OFF_REQUEST_FAILURE: 'DELETE_OFF_REQUEST_FAILURE',
};
export const LEAVE_ACTION_TYPES = {
    CREATE_LEAVE_REQUEST: 'CREATE_LEAVE_REQUEST',
    CREATE_LEAVE_SUCCESS: 'CREATE_LEAVE_SUCCESS',
    CREATE_LEAVE_FAILURE: 'CREATE_LEAVE_FAILURE',
    GET_ALL_LEAVES_REQUEST: 'GET_ALL_LEAVES_REQUEST',
    GET_ALL_LEAVES_SUCCESS: 'GET_ALL_LEAVES_SUCCESS',
    GET_ALL_LEAVES_FAILURE: 'GET_ALL_LEAVES_FAILURE',
    UPDATE_LEAVE_REQUEST: 'UPDATE_LEAVE_REQUEST',
    UPDATE_LEAVE_SUCCESS: 'UPDATE_LEAVE_SUCCESS',
    UPDATE_LEAVE_FAILURE: 'UPDATE_LEAVE_FAILURE',
    DELETE_LEAVE_REQUEST: 'DELETE_LEAVE_REQUEST',
    DELETE_LEAVE_SUCCESS: 'DELETE_LEAVE_SUCCESS',
    DELETE_LEAVE_FAILURE: 'DELETE_LEAVE_FAILURE',

    GET_LEAVE_DETAILS_REQUEST: "GET_LEAVE_DETAILS_REQUEST",
    GET_LEAVE_DETAILS_SUCCESS: "GET_LEAVE_DETAILS_SUCCESS",
    GET_LEAVE_DETAILS_FAILURE: "GET_LEAVE_DETAILS_FAILURE",
};

export const CHECK_ACTION_TYPES = {
    ADD_CHECKIN: 'ADD_CHECKIN',
    UPDATE_CHECKIN: 'UPDATE_CHECKIN',
    DELETE_CHECKIN: 'DELETE_CHECKIN',
};

export const CHECKIN_ACTION_TYPES = {
    CREATE_CHECKIN_REQUEST: 'CREATE_CHECKIN_REQUEST',
    CREATE_CHECKIN_SUCCESS: 'CREATE_CHECKIN_SUCCESS',
    CREATE_CHECKIN_FAILURE: 'CREATE_CHECKIN_FAILURE',
};



export const ANNOUNCEMENTS_ACTION_TYPE = {
    CREATE_REQUEST: "CREATE_REQUEST",
    CREATE_SUCCESS: "CREATE_SUCCESS",
    CREATE_FAILURE: "CREATE_FAILURE",

    UPDATE_REQUEST: "UPDATE_REQUEST",
    UPDATE_SUCCESS: "UPDATE_SUCCESS",
    UPDATE_FAILURE: "UPDATE_FAILURE",

    GET_BY_ID_REQUEST: "GET_BY_ID_REQUEST",
    GET_BY_ID_SUCCESS: "GET_BY_ID_SUCCESS",
    GET_BY_ID_FAILURE: "GET_BY_ID_FAILURE",

    GET_REQUEST: "GET_REQUEST",
    GET_SUCCESS: "GET_SUCCESS",
    GET_FAILURE: "GET_FAILURE",

    REMOVE_REQUEST: "REMOVE_REQUEST",
    REMOVE_SUCCESS: "REMOVE_SUCCESS",
    REMOVE_FAILURE: "REMOVE_FAILURE"
}

export const HOLIDAYS_ACTION_TYPE = {
    CREATE_REQUEST: "CREATE_HOLIDAY_REQUEST",
    CREATE_SUCCESS: "CREATE_HOLIDAY_SUCCESS",
    CREATE_FAILURE: "CREATE_HOLIDAY_FAILURE",

    UPDATE_REQUEST: "UPDATE_HOLIDAY_REQUEST",
    UPDATE_SUCCESS: "UPDATE_HOLIDAY_SUCCESS",
    UPDATE_FAILURE: "UPDATE_HOLIDAY_FAILURE",

    GET_BY_ID_REQUEST: "GET_BY_ID_HOLIDAY_REQUEST",
    GET_BY_ID_SUCCESS: "GET_BY_ID_HOLIDAY_SUCCESS",
    GET_BY_ID_FAILURE: "GET_BY_ID_HOLIDAY_FAILURE",

    GET_REQUEST: "GET_HOLIDAY_REQUEST",
    GET_SUCCESS: "GET_HOLIDAY_SUCCESS",
    GET_FAILURE: "GET_HOLIDAY_FAILURE",

    REMOVE_REQUEST: "REMOVE_HOLIDAY_REQUEST",
    REMOVE_SUCCESS: "REMOVE_HOLIDAY_SUCCESS",
    REMOVE_FAILURE: "REMOVE_HOLIDAY_FAILURE"
}

export const OVERTIME_ACTION_TYPE = {
    CREATE_REQUEST: "OVERTIME/CREATE_REQUEST",
    CREATE_SUCCESS: "OVERTIME/CREATE_SUCCESS",
    CREATE_FAILURE: "OVERTIME/CREATE_FAILURE",

    GET_ALL_REQUEST: "OVERTIME/GET_ALL_REQUEST",
    GET_ALL_SUCCESS: "OVERTIME/GET_ALL_SUCCESS",
    GET_ALL_FAILURE: "OVERTIME/GET_ALL_FAILURE",

    UPDATE_STATUS_REQUEST: "OVERTIME/UPDATE_STATUS_REQUEST",
    UPDATE_STATUS_SUCCESS: "OVERTIME/UPDATE_STATUS_SUCCESS",
    UPDATE_STATUS_FAILURE: "OVERTIME/UPDATE_STATUS_FAILURE",
    
    UPDATE_REQUEST: "OVERTIME/UPDATE_REQUEST",
    UPDATE_SUCCESS: "OVERTIME/UPDATE_SUCCESS",
    UPDATE_FAILURE: "OVERTIME/UPDATE_FAILURE",
}